import React, { useState } from "react";
import { Avatar } from "antd";
import './Avatar.css';

const renderUrl = ({ url, name, logo, avatar }) => {
	const urlParams = new URL(url);
	urlParams.searchParams.set("Authorization", sessionStorage.getItem("token"));
	if (name) urlParams.searchParams.set("name", name);
	if (logo) urlParams.searchParams.set("logo", logo);
	if (avatar) urlParams.searchParams.set("avatar", "true");
	return urlParams.href;
};

function CustomAvatar({
	image,
	name = "",
	color = "#2c77f9",
	size = "default",
	style = {},
	className = "",
	url = null
}) {
	const [hasImageError, setHasImageError] = useState(false);

	const src = !hasImageError
		? (url ? renderUrl(url) : image)
		: null;

	let initials = "";
	if (!src) {
		const words = typeof name === "string" ? name.split(" ") : [];
		initials = words.slice(0, 2).map(w => w.charAt(0)).join("").toUpperCase() || "NN";
	}

	return (
		<Avatar
			className={className}
			style={{
				backgroundColor: color,
				marginRight: '5px',
				...style,
			}}
			size={size}
			src={src}
			onError={() => {
				setHasImageError(true);
				return false; // evita que el Avatar siga intentando renderizar la imagen
			}}
		>
			{!src ? initials : null}
		</Avatar>
	);
}

export default React.memo(CustomAvatar);
